/**
 * RWD JS
 * Disable click on mobile // Move menu on resize
 * ---> Use jQuery
 */

;(function rwdmenu($) {

    $(document).ready(init);

    var CONTAINER_CLASS = 'header';
    var TITLE_CLASS = '.js-RwdMenu-link';
    var MENU_CLASS = '.js-RwdMenu-menu';
    var BUTTON_CLASS = '.js-RwdMenu-btn';
    var WRAPPER_CLASS = '.RwdMenu-wrapper';

    var BREAKPOINT = 1100;
    var DELAY = 50;

    function init() {
        var container = $(CONTAINER_CLASS);

        if (container.length >  0) {
            // 1
            changeLink();
            $(window).on('resize', wait);

            // 2
            container.on('click', BUTTON_CLASS, changeState);

            $(document).mouseup(function (e) {
                console.log("dddd");
                if(getState() === 'open'){
                    console.log("d2d2d2d2");
                    console.log(!$(WRAPPER_CLASS).is(e.target));
                    console.log($(WRAPPER_CLASS).has(e.target).length);
                    if (!$(WRAPPER_CLASS).is(e.target) // if the target of the click isn't the container...
                        && $(WRAPPER_CLASS).has(e.target).length === 0) // ... nor a descendant of the container
                    {
                        console.log("ok");
                        changeState();
                    }
                }
            });

        }
    }

    /*-----------------------------------------------------------
        1 - Disable href on mobile/tablet to able the dropdown
    -----------------------------------------------------------*/
    var wait = debounce(function() {changeLink()}, DELAY);

    function changeLink() {
        var target = $(TITLE_CLASS);
        var viewportWidth = $(window).width();

        if (viewportWidth < BREAKPOINT ) {
            target.each(function() {
                $(this).attr('onclick','return false;');
            });
        } else {
            target.each(function() {
                $(this).attr('onclick','');
            });
        }
    }


    /*-----------------------------------------------------------
        2 - Open - close the menu
    ------------------------------------------------------------*/
    function changeState() {
        var menu = $(MENU_CLASS);
        console.log("change state");
        console.log(menu.attr('data-state'));
        if (menu.attr('data-state') === 'close') {
            menu.attr('data-state', 'open');
            $('body').css('overflow','hidden');
        } else {
            menu.attr('data-state', 'close');
            $('body').css('overflow','');
        }
    }

    function getState() {
        var menu = $(MENU_CLASS);
        return menu.attr('data-state')
    }

})(jQuery);
